import {Component, EventEmitter, Output, Injector, OnInit, OnDestroy} from '@angular/core';
declare const $;
import { JSProxyService } from "../../../services/jsproxy.service";
import { AccessRights, UsersService, InterfacePermissions } from "../../../services/users.service";

@Component({
    selector: 'app-dispatcher-side-nav',
    templateUrl: './dispatcher-side-nav.component.html',
    styleUrls: ['./dispatcher-side-nav.component.css'],
    standalone: false
})
export class DispatcherSideNavComponent implements OnInit,OnDestroy {
  public AccessRights = AccessRights;
  public InterfacePermissions = InterfacePermissions;

  @Output() onComponentSelected: EventEmitter<any> = new EventEmitter();

  public selectedTab: string = "dispatcher_table";

  jsProxy: JSProxyService;
  public usersService: UsersService;
  constructor(protected injector: Injector) {
    this.jsProxy = injector.get(JSProxyService);
    this.usersService = injector.get(UsersService);
  }
  ngOnInit() {
    //this.jsProxy.registerComponent("DriversPage", this, "");
  }
  ngOnDestroy() {
    //this.jsProxy.unRegisterComponent("DriversPage");
  }

  public select(name: string) {
    this.onComponentSelected.emit(name);
    this.selectedTab = name;
  }

  public isSelected(name: string): boolean {
    return this.selectedTab == name;
  }
  public toggleMenu()
  {
    var trigger = $('.js-sidemenu-trigger');
    trigger.toggleClass('is-active');
    var parent = trigger.parents('.js-page');
    parent.toggleClass('menu-opened');
  }
}
